var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"height":_vm.radius * 2,"width":_vm.radius * 2}},[_c('circle',{style:({
            strokeDashoffset: _vm.strokeDashoffset,
            'transition-duration': `${_vm.duration}s`,
        }),attrs:{"stroke":_vm.color,"stroke-dasharray":_vm.circumference + ' ' + _vm.circumference,"stroke-width":_vm.stroke,"fill":"transparent","r":_vm.normalizedRadius,"cx":_vm.radius,"cy":_vm.radius}})])
}
var staticRenderFns = []

export { render, staticRenderFns }